import { useContext } from 'react';

import { XYChartColorScalesContext } from '../context/XYChartColorScalesContext.js';

export const useXYChartColorScales = () => {
  const context = useContext(XYChartColorScalesContext);

  if (context === undefined) {
    throw new Error(
      'useXYChartColorScales must be used within a XYChartColorScaleContext',
    );
  }

  return context;
};
